import styled from 'styled-components';
import React, {FC} from 'react';

import {palette, mediaBreakpointDown} from '../../../../lib/styleVariables';
import {FieldButton} from '../../../molecules/buttons';
import {Input} from '../../../molecules/inputs';
import {NavigationCallToActionBase} from './navigationCallToActionBase';
import {NavigationCallToActionSectionTitle} from './navigationCallToActionSectionTitle';

interface NavigationCallToActionProps {
  color?: 'gray' | 'black' | 'blue';
  title: React.ReactNode;
  submitUrl?: string;
  inputPlaceholder: string;
  buttonLabel: string;
}

const StyledForm = styled.form`
  display: flex;
  ${mediaBreakpointDown('mobile')} {
    flex-direction: column;
  }
`;

const StyledFieldButton = styled(FieldButton)<{ctaTheme?: string}>`
  margin-left: 8px;
  border: 3px solid ${props => (props.ctaTheme === 'black' ? palette.blue.base : palette.black.base)};
  background: ${props => (props.ctaTheme === 'black' ? palette.blue.base : palette.black.base)};
  padding-top: 8px;
  padding-bottom: 8px;
  transition-property: background, color, box-shadow;
  line-height: 113%;

  &:hover {
    background: ${props => (props.ctaTheme === 'black' ? 'transparent' : palette.white.highlight)};
    color: ${props => (props.ctaTheme === 'black' ? palette.white.highlight : palette.black.base)};
  }

  ${mediaBreakpointDown('mobile')} {
    margin-top: 16px;
    margin-left: 0;
    width: 100%;
  }
`;

const StyledInput = styled(Input)`
  border: none;
  width: 288px;
  ${mediaBreakpointDown('mobile')} {
    width: 100%;
  }
`;

export const NavigationCTASignup: FC<NavigationCallToActionProps> = props => {
  const {color, title, submitUrl, inputPlaceholder, buttonLabel} = props;

  return (
    <NavigationCallToActionBase
      color={color}
      renderLeft={() => (
        <NavigationCallToActionSectionTitle color={color}>{title}</NavigationCallToActionSectionTitle>
      )}
      renderRight={() => (
        <StyledForm action={submitUrl} method="post">
          <StyledInput onDarkBackground placeholder={inputPlaceholder} type="email" name="input" />
          <StyledFieldButton ctaTheme={color} isHover>
            {buttonLabel}
          </StyledFieldButton>
        </StyledForm>
      )}
    />
  );
};
